import React from 'react';
import {
  format,
  startOfMonth,
  parse,
  isValid,
  isAfter,
  isBefore
} from 'date-fns';
import { Controller } from 'react-hook-form';
import { Col, Row } from 'reactstrap';
import Datepicker from 'components/Inputs/DatePicker';
import { ErrorMessage } from '@hookform/error-message';

const dateRules = {
  pattern: {
    value: /^[0-3][0-9]\/[0-1][0-9]\/[0-9]{4}$/,
    message: 'Data inválida! (dd/MM/aaaa)'
  }
};

const getDateBegin = () => {
  const date = new Date();
  const firstDayMonth = new Date(date.getFullYear(), date.getMonth(), 1);
  return format(startOfMonth(firstDayMonth), 'dd/MM/yyyy');
};

const parseDDMMYYYYToDate = (dateStr) => {
  if (!dateStr) return null;
  const parsed = parse(dateStr, 'dd/MM/yyyy', new Date());
  return isValid(parsed) ? parsed : null;
};

const errorFormMessage = (message) => (
  <p style={{ color: 'red', marginTop: '4px' }}>{message}</p>
);

const DefaultFieldsFilterForm = ({ control, setValue, getValues, errors }) => {
  return (
    <Row className="mb-3">
      <Col sm="6">
        <label className="form-control-label">Data inicial</label>
        <Controller
          name="dateBegin"
          control={control}
          defaultValue={getDateBegin()}
          rules={{
            ...dateRules,
            validate: (value) => {
              const dateEnd = getValues('dateEnd');
              const begin = parseDDMMYYYYToDate(value);
              const end = parseDDMMYYYYToDate(dateEnd);
              if (begin && end && isAfter(begin, end)) {
                return 'A data inicial não pode ser posterior à data final!';
              }
              return true;
            }
          }}
          render={(props) => (
            <Datepicker
              fieldName="dateBegin"
              valueController={setValue}
              defaultValue={props.value}
            />
          )}
        />
        <ErrorMessage
          errors={errors}
          name="dateBegin"
          render={({ message }) => errorFormMessage(message)}
        />
      </Col>
      <Col sm="6">
        <label className="form-control-label">Data final</label>
        <Controller
          name="dateEnd"
          control={control}
          defaultValue={new Date().toLocaleDateString('pt-BR')}
          rules={{
            ...dateRules,
            validate: (value) => {
              const dateBegin = getValues('dateBegin');
              const end = parseDDMMYYYYToDate(value);
              const begin = parseDDMMYYYYToDate(dateBegin);
              if (begin && end && isBefore(end, begin)) {
                return 'A data final não pode ser anterior à data inicial!';
              }
              return true;
            }
          }}
          render={(props) => (
            <Datepicker
              fieldName="dateEnd"
              valueController={setValue}
              defaultValue={props.value}
            />
          )}
        />
        <ErrorMessage
          errors={errors}
          name="dateEnd"
          render={({ message }) => errorFormMessage(message)}
        />
      </Col>
    </Row>
  );
};

export default DefaultFieldsFilterForm;
